
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/kayaba",
      function () {
        return require("private-next-pages/cases/kayaba/index.tsx");
      }
    ]);
  